import { render, staticRenderFns } from "./serviceChargeCell.vue?vue&type=template&id=25037e8e&scoped=true"
import script from "./serviceChargeCell.vue?vue&type=script&lang=js"
export * from "./serviceChargeCell.vue?vue&type=script&lang=js"
import style0 from "./serviceChargeCell.vue?vue&type=style&index=0&id=25037e8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25037e8e",
  null
  
)

export default component.exports